import React, { useState } from 'react';
import styles from './TimeLine.module.css';

import SampleAvatar from './../../../assets/images/Photo.png';
import Dropdown from '../../../components/Dropdown/Dropdown';
import TabSelector from '../../../components/TabSelector/TabSelector';

const TimeLine = () => {
  const today = new Date();
  const [calendarMode, setCalendarMode] = useState('Auto');
  const [selectedFilter, setSelectedFilter] = useState('Show All Updates');
  const [selectedYear, setSelectedYear] = useState(
    today.getFullYear().toString()
  );
  const [selectedMonth, setSelectedMonth] = useState(
    today.toLocaleString('default', { month: 'long' })
  );

  const filterOptions = [
    { label: 'Show All Updates', value: 'all' },
    { label: 'Assignments', value: 'assignments' },
    { label: 'Notes', value: 'notes' },
  ];

  const calendarOptions = [{ label: 'Auto' }, { label: 'Calendar' }];

  const years = ['2023', '2024', '2025'];
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const getDaysInMonth = (year, month) => {
    const monthIndex = months.indexOf(month);
    const firstDay = new Date(year, monthIndex, 1);
    const lastDay = new Date(year, monthIndex + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startDay = firstDay.getDay();

    const calendarCells = [];

    // Fill empty cells for start offset
    for (let i = 0; i < startDay; i++) {
      calendarCells.push(null);
    }

    // Fill date numbers
    for (let day = 1; day <= daysInMonth; day++) {
      calendarCells.push(day);
    }

    return calendarCells;
  };

  const calendarDates = getDaysInMonth(selectedYear, selectedMonth);

  return (
    <div className={styles.timelineWrapper}>
      {/* Left Card */}
      <div className={styles.leftCard}>
        <img src={SampleAvatar} alt="avatar" className={styles.avatar} />
        <h4 className={styles.name}>John Jacob</h4>
        <p className={styles.className}>3A</p>
        <p className={styles.noActivity}>No activity posted on 26/06/2025.</p>
        <p className={styles.secondaryText}>Showing past activities</p>
      </div>

      {/* Right Card */}
      <div className={styles.rightCard}>
        <div className={styles.filterSection}>
          {/* Top Controls: TabSelector + Filter */}
          <div className={styles.topControls}>
            <h4 className={styles.sectionTitle}>Enable Calendar Mode</h4>
            <TabSelector
              options={calendarOptions}
              activeTab={calendarMode}
              setActiveTab={setCalendarMode}
            />
          </div>

          <div className={styles.topControls}>
            <p className={styles.filterLabel}>Filter By</p>
            <Dropdown
              label="Show All Updates"
              options={filterOptions.map((opt) => opt.label)}
              onChange={(val) => setSelectedFilter(val)}
              showAllOption={false}
            />
          </div>
        </div>

        {/* Calendar View */}
        {calendarMode === 'Calendar' && (
          <>
            <div className={styles.dropdownRow}>
              <Dropdown
                label={selectedYear}
                options={years}
                onChange={(val) => setSelectedYear(val)}
                showAllOption={false}
              />
              <Dropdown
                label={selectedMonth}
                options={months}
                onChange={(val) => setSelectedMonth(val)}
                showAllOption={false}
              />
            </div>

            <div className={styles.calendarGrid}>
              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(
                (day, idx) => (
                  <div key={idx} className={styles.day}>
                    {day}
                  </div>
                )
              )}

              {calendarDates.map((day, idx) => {
                const isToday =
                  today.getFullYear().toString() === selectedYear &&
                  months[today.getMonth()] === selectedMonth &&
                  today.getDate() === day;

                return (
                  <div
                    key={idx}
                    className={`${styles.date} ${isToday ? styles.today : ''}`}
                  >
                    {day ? String(day).padStart(2, '0') : ''}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TimeLine;
